import { Label } from '@shared/components/ui/label';
import { Switch } from '@shared/components/ui/switch';
import { Column } from '@tanstack/react-table';

interface DataTableBooleanFilterProps<TData> {
  column: Column<TData, unknown>;
  title: string;
}

export function DataTableBooleanFilter<TData>({
  column,
  title,
}: DataTableBooleanFilterProps<TData>) {
  const checked = column.getFilterValue() === true;
  const id = `filter-${column.id}`;

  return (
    <div className="flex h-8 items-center gap-2 rounded-md border border-dashed border-input px-3 text-xs">
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={(next) =>
          column.setFilterValue(next ? true : undefined)
        }
      />
      <Label htmlFor={id} className="cursor-pointer text-xs">
        {title}
      </Label>
    </div>
  );
}
